import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './sa_reboot.routes';

import CompanyService from '../../../components/api/company/company.service';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import ControllerConfigService from '../../../components/api/controller_config/controller_config.service';

export class OemSaRebootController {
    /*@ngInject*/
    constructor($stateParams, $q, CompanyService, SaConfigService, ControllerConfigService) {
      this.company_id = $stateParams.company_id;
      this.$q = $q;
      this.CompanyService = CompanyService;
      this.SaConfigService = SaConfigService;
      this.ControllerConfigService = ControllerConfigService;

      this.devices = [];
    }

    $onInit() {
      this.CompanyService.show({ id: this.company_id }, response => {
        this.company = response;
      }, err => {
        if(err.status === 404 || err.status === 403) { this.$state.go('oem_main.oem_home'); }
      });

      this.$q.all([
        this.SaConfigService.oem_api.index({ company_id: this.company_id }).$promise,
        this.ControllerConfigService.oem_api.index({company_id: this.company_id}).$promise
      ]).then(responses => {
        this.devices = responses[0].concat(responses[1]);
      });
    }
}

export default angular.module('leptonApp.oemSaReboot', [uiRouter, CompanyService, SaConfigService, ControllerConfigService])
  .config(routing)
  .component('oemSaReboot', {
    template: require('./sa_reboot.html'),
    controller: OemSaRebootController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/sa_reboot/oem/sa_reboot.component.js